import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styles from "../ResetPin/resetPin.module.css"; // Import CSS module
import checkmark from '../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import knowioLogo from '../assets/knowio-logo.png'
import parfasLogo from '../assets/parfas-logo.png'
import portalLogo from '../assets/portal-logo.png'
import magnumLogo from '../assets/magnum-logo.png'
import resureLogo from '../assets/resure-logo.png'
import eesLogo from '../assets/ees-logo.png'
import towerLogo from '../assets/tower-logo.png'
import solarLogo from '../assets/solar-logo.png'
import { set } from "date-fns";

const RegisterSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");
    let appName = searchParams.get("appName")
    const userName = searchParams.get("userName");
    const [appLink, setAppLink] = useState("");
    const [isWeb, setIsWeb] = useState(false)
    const [androidLink, setAndroidLink] = useState("")
    const [iOSLink, setiOSLink] = useState("")
 
    if (appName == "RE:SURE"){
        appName = "RESURE"
    }
    if (appName == "Magnum Security" || appName == "MAGNUM_SECURITY"){
        appName = "Magnum"
    }

    let logoMapping = [
        knowioLogo, 
        resureLogo, 
        parfasLogo, 
        magnumLogo, 
        portalLogo, 
        eesLogo,
        towerLogo,
        solarLogo
    ]

    let icon;

    switch (appName){
        case "RESURE":
            icon = logoMapping[1]
        break;
        case "KNOWIO":
            icon = logoMapping[0]
        break;
        case "Magnum":
            icon = logoMapping[3]
        break;
        case "PORTAL_SECURITY":
            icon = logoMapping[4]
        break;
        case "PARFAS":
            icon = logoMapping[2]
        break;
        case "EES":
            icon = logoMapping[5]
        break;
        case "TOWER":
            icon = logoMapping[6]
        break;
        case "SOLAR":
            icon = logoMapping[7]
        break;
    }

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (appName == "RESURE" || appName == "RE:SURE"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=resureio.resure.com.resureio&hl=en_GB&gl=US"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/us/app/re-sure-i-o/id1046871278"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=resureio.resure.com.resureio&hl=en_GB&gl=US")
                setiOSLink("https://apps.apple.com/us/app/re-sure-i-o/id1046871278");
            }
        } else if (appName == "KNOWIO" || appName == "Knowio"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.knowio&hl=en_US"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/ie/app/knowio/id6476141189"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.knowio&hl=en_US"); // Android deep link
                setiOSLink("https://apps.apple.com/ie/app/knowio/id6476141189"); // iOS deep link
            }
        } else if (appName == "Magnum Security" || appName == "MAGNUM_SECURITY" || appName == "Magnum"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.magnum&hl=en&gl=US"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/tr/app/magnum-security/id6451967278"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.magnum&hl=en&gl=US"); // Android deep link
                setiOSLink("https://apps.apple.com/tr/app/magnum-security/id6451967278"); // iOS deep link
            }
        } else if (appName == "Portal Security" || appName == "PORTAL_SECURITY"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.portal&hl=en&gl=US"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/gb/app/portal-security/id1551776651"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.portal&hl=en&gl=US"); // Android deep link
                setiOSLink("https://apps.apple.com/gb/app/portal-security/id1551776651"); // iOS deep link
            }
        } else if (appName == "Parfas" || appName == "PARFAS"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.parfas&hl=en_ZA"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/gb/app/parfas-in-control/id1439793903"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.parfas&hl=en_ZA"); // Android deep link
                setiOSLink("https://apps.apple.com/gb/app/parfas-in-control/id1439793903"); // iOS deep link
            }
        } else if (appName == "EES" || appName == "ees"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.ees&hl=en_GB"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/gb/app/ees-control/id1607835755"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.ees&hl=en_GB"); // Android deep link
                setiOSLink("https://apps.apple.com/gb/app/ees-control/id1607835755"); // iOS deep link
            }
        } else if (appName == "TOWER" || appName == "Tower Security"){
            if (/android/i.test(userAgent)) {
                setAppLink("https://play.google.com/store/apps/details?id=inniovate.towersecurity.com"); // Android deep link
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                setAppLink("https://apps.apple.com/ng/app/offgrid-tower-security/id6748463303?uo=2"); // iOS deep link
            } else {
                setIsWeb(true)
                setAndroidLink("https://play.google.com/store/apps/details?id=inniovate.towersecurity.com"); // Android deep link
                setiOSLink("https://apps.apple.com/ng/app/offgrid-tower-security/id6748463303?uo=2"); // iOS deep link
            }
        } 
        // else if (appName == "SOLAR" || appName == "Solar Safe"){
        //     if (/android/i.test(userAgent)) {
        //         setAppLink("https://play.google.com/store/apps/details?id=ipio.eyespyfx.com.ees&hl=en_GB"); // Android deep link
        //     } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        //         setAppLink("https://apps.apple.com/gb/app/ees-control/id1607835755"); // iOS deep link
        //     } else {
        //        setIsVisible(false)
        //     }
        // }
    }, []);

    return (
        <div className={`${styles.container} ${styles[appName]}`}>
            <div className={`${styles.card} ${styles[appName]}`}>
                <img style={{width: "100px", height:"100px", borderRadius:"10px"}} src={icon}></img>
                <h1 className={styles.title}>Your account has been created! 🎉</h1>
                <p className={styles.subTitle}>You can now access the site you were invited to using the {appName} app</p>
            <br></br>
            <p className={styles.subTitle}>Not got the app? Download it here:</p>
            <br></br>
                 {!isWeb && (
                    <a href={appLink} style={{ padding: "10px 20px", background: "#007bff", color: "white", borderRadius: "5px", textDecoration: "none" }}>
                        Download App
                    </a>)}
                    
                {isWeb && (
                    <div style={{ display: "flex", gap: "10px" }}>
                        <a href={androidLink} style={{ padding: "10px 20px", background: "#007bff", color: "white", borderRadius: "5px", textDecoration: "none" }}>
                            Download for Android
                        </a>
                        
                        <a href={iOSLink} style={{ padding: "10px 20px", background: "#007bff", color: "white", borderRadius: "5px", textDecoration: "none" }}>
                            Download for iOS
                        </a>
                    </div>
                )}
                <br></br>
            </div>
        </div>
    );
};

export default RegisterSuccess;
